<template>
  <div class="slider-recommend pb-6 md:pb-8 border-b w-full">
    <h3 class="tracking-wider text-center mb-0 py-5 lg:py-8 text-lg lg:text-xl text-NotoSansBold textColorBlack">站長推薦</h3>
    <swiper :options="friendlyOption" class="swiper w-full">
      <swiper-slide v-for="(item, index) in friendlyData" :key="index" class="item cursor-pointer flex flex-col">
        <a class="cursor-pointer w-full" :href="item.url" target="_blank">
          <div class="slider-img sm:px-2 flex justify-center w-full mb-2 md:mb-3 lg:mb-4 cursor-pointer">
            <img v-lazy="item.image_url" class="w-full h-full" :alt="item.name">
          </div>
        </a>
      </swiper-slide>
    </swiper>
  </div>
</template>

<script>
export default {
  props: {
    friendlyData: {
      type: Array
    }
  },
  data () {
    return {
      friendlyOption: {
        lazyLoading: true,
        observer: true,
        observeParents: true,
        slidesPerView: 2,
        spaceBetween: 10,
        loop: false,
        autoplay: {
          delay: 5000
        },
        breakpoints: {
          576: {
            lazyLoading: true,
            observer: true,
            observeParents: true,
            slidesPerView: 1,
            spaceBetween: 10,
            loop: true,
            autoplay: {
              delay: 5000
            }
          }
        }
      }
    }
  }
}
</script>
